import { convertMsToSeconds } from './utilities.time';
export function getStreamDurationInSeconds(params) {
    const { duration, durationIsInMs } = params;
    if (duration === undefined || duration === Number.POSITIVE_INFINITY)
        return -1;
    return durationIsInMs ? convertMsToSeconds(Number(duration)) : Number.isFinite(+duration) ? Number(duration) : -1;
}
export function validatePrid(prid) {
    return prid !== '' && prid !== undefined ? prid : 'unknown';
}
